import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {useNavigate, useParams} from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function ViewEmployee() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [empData, setempData] = useState({});
    useEffect(() => {
        fetchempData();
    }, []);
    function fetchempData() {
        const url = `${baseUrl}edit-emp/${id}/`;
        axios.get(url)
            .then(response => {
                setempData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-10 col-12 offset-1">
                    <div className='card'>
                        <h4 className='card-header text-center'>Employee Details</h4>
                        <div className='card-body'>
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="Role" className="form-label">Employee ID / Name</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.emp_id}</span>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.employee}</span>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="Gender" className="form-label">Gender</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.gender}</span>
                                    </div>
                                    <div className="col-md-1">
                                        <img src={empData.employee_pic} alt="Thumbnail" className="thumbnail"
                                             style={{width: 120, height: 60}}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Age" className="form-label">Age</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.age}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Mobile" className="form-label">Mobile</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.mobile}</span>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Address" className="form-label">Address</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.address}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Marital" className="form-label">Marital Status</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.marital}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Blood Group" className="form-label">Blood Group</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.blood}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Religion" className="form-label">Religion</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.religion}
                            </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Alt No" className="form-label">Alternate No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.alt_contact}
                            </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Email" className="form-label">Email</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.email} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aadhar" className="form-label">Aadhar</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.adhar} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="PAN No" className="form-label">PAN No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.pan} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aadhar" className="form-label">Passport No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.passport} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Status" className="form-label">Employment Status</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.emp_status}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Date" className="form-label">Date of Joining</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.doj}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="education" className="form-label">Education
                                            Qualification</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.education} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aadhar" className="form-label">Experience</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.experience} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="Department" className="form-label">Department</label>
                                        <span style={{fontWeight: 'bold'}}
                                              className="ms-2">{empData.department && empData.department.department}</span>
                                        -<span style={{fontWeight: 'bold'}}
                                               className="ms-3">{empData.designation && empData.designation.designation}</span>
                                    </div>
                                </div>
                                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                                    <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"
                                       style={{color: 'red'}}></i>
                                    Account Details
                                </h3>
                                <div className="row mt-4">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Account No" className="form-label">Bank Account No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.account} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Bank Branch Detail" className="form-label">Bank Branch
                                            Detail</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.branch} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="ESI No" className="form-label">ESI No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.esi} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="PF No" className="form-label">PF No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.pf} </span>
                                    </div>
                                </div>
                                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                                    <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"
                                       style={{color: 'red'}}></i>
                                    Salary Details
                                </h3>
                                <div className="row mt-4">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Basic Salary" className="form-label">Basic Salary</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.basic} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Prof Tax" className="form-label">Prof Tax</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-1">{empData.prof} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="HRA" className="form-label">HRA</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.hra} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="TDS" className="form-label">TDS</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-1">{empData.tds} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Allowance" className="form-label">Allowance</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.allowance} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Other Deduction" className="form-label">Other Deduction</label>
                                        <span style={{fontWeight: 'bold'}}
                                              className="ms-1">{empData.other_deduct} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Spl Allowance" className="form-label">Spl Allowance</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.spl} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="TDS" className="form-label">Employee PF Contri. @12%</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.empf} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Other Earnings" className="form-label">Other Earnings</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.other_earn} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Empl ESI" className="form-label">Employee ESI @0.75%</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.emesi} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Earnings per Month" className="form-label">Total Earnings/
                                            Month</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.earnings} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Total Deduction per Month" className="form-label">Total
                                            Deduction/ Month</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.deduction} </span>
                                    </div>
                                    <div className="col-md-2 mb-2">
                                        <label htmlFor="CTC per Month" className="form-label">Total CTC</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.ctc}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default ViewEmployee;
